<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
        <b-col class="p-l-0">
            <label>Observação</label>
            <b-form-input type="text"
                    placeholder="Observação"
                    v-model="form.obs"
                    name="obs">
            </b-form-input>
        <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
        </b-col>
        <b-col class="p-l-0">
            <label>Status</label>
            <multiselect v-model="statusSelected"
            :options="optionsLivStatusCliente"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>
        </b-col>
        <b-col class="p-l-0">
            <label>Automático</label>
            <multiselect v-model="automaticoSelected"
            :options="optionsLivAutomatico"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('automatico')" v-if="form.errors.has('automatico')"></b-form-feedback>
        </b-col>
        <b-col class="p-l-0">
            <label>Transportadora</label>
            <multiselect
            v-model="pessoaSelected"
            :options-limit="300"
            :limit="2"
            :limit-text="limitText"
            :options="optionsTransportadora"
            track-by="value"
            label="label"
            id="transportadora"
            :hide-selected="true"
            placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            :searchable="true"
            :loading="isLoadingTransportadora"
            @search-change="listaTransportadora"
            ></multiselect>
            <b-form-feedback class="text-danger" v-text="form.errors.get('cliente')" v-if="form.errors.has('cliente')"></b-form-feedback>
        </b-col>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import { formatCNPJFromParts } from "../utils";


export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      isLoadingTransportadora: false,
      pessoaSelected: [],
      automaticoSelected: [],
      statusSelected: [],
      optionsLivAutomatico: [],
      optionsLivStatusCliente: [],
      transportadora: [],
      optionsTransportadora: [],
      optionsCliente: [],
      pessoa_id: [],
      form: new Form({ pessoa_id: '', regfis_id: '', obs: '', automatico: '', status: '', regfiscli_id: ''}),
     helpForm: new Form({statusRecord: [], params: [], search: ''}),
    fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    pessoaSelected(obj) {
        this.form.pessoa_id = obj.value;
    },
    statusSelected(obj) {
        this.form.status = obj.value;
    },
    automaticoSelected(obj) {
        this.form.automatico = obj.value;
    }
},
mounted() {
    this.getLivGeral();
},
created() {
    let self = this;
    Event.$on('editCliente', function (data) {
        self.onEdit(data);
    });
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.regfistra_id);
        }
    },
    onCreate (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.automaticoSelected = [];
      this.statusSelected = [];
      this.pessoaSelected = [];
      this.form.regfis_id = data.regfis_id;
      this.$refs.modal_form.show();
    },
    onEdit (data) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.automaticoSelected = [];
        this.statusSelected = [];
        this.pessoaSelected = [];
        this.form.obs = data.obs;
        this.form.regfistra_id = data.regfistra_id;
        this.automaticoSelected    = { label: data.automatico.descr, value: data.automatico.valor };
        this.statusSelected    = { label: data.status.descr, value: data.status.valor };
        if(data.pessoa.tipo_pessoa==2)//Juridica
        {
            this.pessoaSelected    = { label: " PJ - "+data.pessoa.cd+" - "+data.pessoa.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(data.pessoa.pessoa_juridica.cnpj_base,data.pessoa.pessoa_juridica.cnpj_filial,data.pessoa.pessoa_juridica.cnpj_digito)+" - "+data.pessoa.pessoa_juridica.inscricao_estadual, value: data.pessoa_id};
        }
        if(data.pessoa.tipo_pessoa==1)//PF
        {
            this.pessoaSelected    = { label: " PF - "+data.pessoa.cd+" - "+data.pessoa.pessoa_fisica.nome+" - "+data.pessoa.pessoa_fisica.cpf, value: data.pessoa_id };
        }
        if(data.pessoa.tipo_pessoa==3)//PE
        {
            this.pessoaSelected    = { label: " PE - "+data.pessoa.cd+" - "+data.pessoa.pessoa_exterior.nome+" - "+data.pessoa.pessoa_exterior.cuit, value: data.pessoa_id };
        }
        this.form.regfis_id = data.regfis_id;
        this.form.regfiscli_id = data.regfiscli_id;
        this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/regrafiscal/trasnportador/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        console.log(id);
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/regrafiscal/trasnportador/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/regrafiscalcliente/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatusCliente.push({ label: obj.descr, value: obj.valor })
            })
            response.automatico.forEach((obj)=>
            {
                this.optionsLivAutomatico.push({ label: obj.descr, value: obj.valor })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    listaTransportadora(search) {
        if (search.length >= 3) {
            this.isLoadingTransportadora = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm
            .post("/api/pessoa/jsonlist/transportadora")
            .then((response) => {
                this.optionsTransportadora = [];
                new ReturnApi(response, this, true, false, false);
                if (response.items.length > 0) {
                response.items.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PJ -" + obj.pessoa.cd + " - " + obj.razao_social + " - " + this.onFormataCnpj( obj.cnpj_base, obj.cnpj_filial, obj.cnpj_digito).replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, "$1.$2.$3/$4-$5") + " - " + obj.inscricao_estadual, pessoa_id: obj.pessoa_id, value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                this.isLoadingTransportadora = false;
            })
            .catch((errors) => {
                new ReturnApi(errors, this);
            });
        }
    },    
    limitText (count) {
      return ' e ${count} outros clientes'
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>